import { render, staticRenderFns } from "./ModalSendToManager.vue?vue&type=template&id=256486de"
import script from "./ModalSendToManager.vue?vue&type=script&lang=js"
export * from "./ModalSendToManager.vue?vue&type=script&lang=js"
import style0 from "./ModalSendToManager.vue?vue&type=style&index=0&id=256486de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports